module.exports = __webpack_public_path__ + "static/media/button_menuwhite.965436b9.svg";